import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a8b7231a880c6b126f2b2e97212be7b6fb from "./generated-a98a5f7c-7234-4b63-821b-29f46b192692.json";

import a9e25875517ec0d8703eed72239834c62b from "./generated-a0499409-b793-4f93-ab93-d9c6b5c1a39b.json";

import aa6e4db4c6c7f07f99411b04411cc42feb from "./generated-afe60d3e-fa58-4927-bb5c-7d15842a353f.json";

import a3d8f327e4ab889dda01298ab78910010b from "./generated-ac9d02a1-3153-406f-a64d-f9af51f994cb.json";

import a99cbaf294997ce21e8b83903ffb3c294b from "./generated-0e6c0046-57a4-4c89-af04-8e2e79829de8.json";

import a9d28d9ce89971c875903929d03094efbb from "./generated-f834575d-bf37-44a9-972f-d4ef7cdf9939.json";

import a1761b621617d13cd2099b8ed793a2be4b from "./generated-819e4d89-56ad-480c-92b5-cb317b6af801.json";

import a4360c595d78d6a9cc2c1bed7664e2959b from "./generated-ee9e687b-bcfb-4fd9-965b-f7f375c07025.json";

import a0a6fbfdee1d7ac75151c354c07390f05b from "./generated-8d4d4ab6-4ac9-4a74-9b6e-f8bd379de681.json";

import acaadba0154cb5af3b3a57863f9d7dd46b from "./generated-40b94f28-183a-42b7-bde6-245e1b7d2d11.json";

import a56ab82395ec32d76eb33d5e183634226b from "./generated-65bdd2c4-3ad1-4059-95ca-766207cf5eac.json";

import a1e5f9bc7e27369fbf676378456e13966b from "./generated-1ba7fc68-2ee2-4e7e-b81a-4ea2ceec7fcd.json";

import a1d5a787612de9095f0114634d09a005bb from "./generated-89946cec-156d-4cdf-9c06-0444ada7c4a7.json";

import a8ee3f45d01c98ba2c47006f2e4656477b from "./generated-5a8731c9-cfda-43ad-995b-96c26fe01275.json";

import a20305d3300f3073e3e2510d8f3ece799b from "./generated-979384b1-e6ba-4d05-8ad0-2c67a1e4ca95.json";

import a5988949783470b076d4ad8681e75f6ffb from "./generated-ebd2c227-d9aa-4b90-845e-2fe04a107504.json";

import a42529ab8f1be3e95a40e5fc62dd6dab3b from "./generated-8c968c51-a390-4651-ae80-fcd8660b73c6.json";

import a490556588107a563f38c13262c0556f0b from "./generated-3dcba55f-7134-4b20-bb98-6325d56f810c.json";

import a5691e069f7784c19fe410e11872b75e3b from "./generated-9cc221f9-b6ec-40f2-9e19-961804330d88.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a8b7231a880c6b126f2b2e97212be7b6fb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a9e25875517ec0d8703eed72239834c62b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(aa6e4db4c6c7f07f99411b04411cc42feb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a3d8f327e4ab889dda01298ab78910010b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a99cbaf294997ce21e8b83903ffb3c294b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a9d28d9ce89971c875903929d03094efbb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a1761b621617d13cd2099b8ed793a2be4b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a4360c595d78d6a9cc2c1bed7664e2959b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a0a6fbfdee1d7ac75151c354c07390f05b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(acaadba0154cb5af3b3a57863f9d7dd46b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a56ab82395ec32d76eb33d5e183634226b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a1e5f9bc7e27369fbf676378456e13966b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a1d5a787612de9095f0114634d09a005bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a8ee3f45d01c98ba2c47006f2e4656477b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a20305d3300f3073e3e2510d8f3ece799b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a5988949783470b076d4ad8681e75f6ffb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a42529ab8f1be3e95a40e5fc62dd6dab3b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a490556588107a563f38c13262c0556f0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a5691e069f7784c19fe410e11872b75e3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a42529ab8f1be3e95a40e5fc62dd6dab3b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */